var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { debounce } from 'lodash';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import Spinner from '@/components/Spinner.vue';
import { formatDate } from '@/utils/string';
import apiGateway from '@/api-gateway';
import { ProjectStatusType } from '@/api-gateway/types/Project';
import AdjustDate from './AdjustDate.vue';
import moment from 'moment';
import Dropdown from '@/components/Dropdown.vue';
import { ImportExcel, ValidationRuleType } from '@/components/excel/';
export default {
    name: 'table-project-list',
    components: {
        Spinner: Spinner,
        AdjustDate: AdjustDate,
        ImportExcel: ImportExcel,
        Dropdown: Dropdown
    },
    data: function () {
        return {
            searchQuery: '',
            gridOptions: {
                rowHeight: 70,
                headerHeight: this.isShowHeaderTable ? 70 : 0
            },
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                resizable: true
            },
            isCheckboxSelection: false,
            selectedPageSize: this.paginationPageSize,
            minimumItemScrollable: 20,
            pageCheckList: '',
            serverCurrentPage: 0,
            isLoadingData: false,
            scrollBottomFired: false,
            canEdit: false,
            isPopupEdit: false,
            isPopupError: false,
            isIndexRow: null,
            isProjectId: null,
            isParam: {},
            validationRules: [
                {
                    header: 'Project System ID',
                    required: true,
                    type: ValidationRuleType.INTEGER,
                    unique: true
                },
                {
                    header: 'Project Name',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Project Category',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Related Program',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Related Property(TH)',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Related Property(EN)',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Approval Date',
                    type: ValidationRuleType.DATE
                },
                {
                    header: 'Target Site Hand Over',
                    type: ValidationRuleType.DATE
                },
                {
                    header: 'Target Grand Opening',
                    type: ValidationRuleType.DATE
                },
                {
                    header: 'Target Present Site',
                    type: ValidationRuleType.DATE
                },
                {
                    header: 'Target 1st CIA',
                    type: ValidationRuleType.DATE
                },
                {
                    header: 'Target TPM/AMD',
                    type: ValidationRuleType.DATE
                },
                {
                    header: 'Target Present Site Font Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Present Site Icon Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Approval Date Font Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Approval Date Icon Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Site Hand Over Font Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Site Hand Over Icon Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Grand Opening Font Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target Grand Opening Icon Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target 1st CIA Font Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target 1st CIA Icon Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target TPM/AMD Font Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Target TPM/AMD Icon Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'First Layout Date',
                    type: ValidationRuleType.DATE
                },
                {
                    header: 'First Layout Date Font Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'First Layout Date Icon Color',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Mall Leasing',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Construction Progress',
                    type: ValidationRuleType.STRING
                },
                {
                    header: 'Mall Construction',
                    type: ValidationRuleType.STRING
                }
            ],
            project_sort: false,
            name: false,
            firstLayoutDate: false,
            targetPresentSiteDate: false,
            targetFirstCIADate: false,
            targetTPMDate: false,
            targetApproveDate: false,
            targetHandOverDate: false,
            targetOpenDate: false,
            projectStatus: [
                { text: 'STATUS', value: '' },
                {
                    text: ProjectStatusType.ONPROCESS,
                    value: ProjectStatusType.ONPROCESS
                },
                { text: ProjectStatusType.ONHOLD, value: ProjectStatusType.ONHOLD },
                { text: ProjectStatusType.COMPLETE, value: ProjectStatusType.COMPLETE }
            ],
            projectStatus_select: ''
        };
    },
    props: {
        headerTitle: {
            type: String,
            default: ''
        },
        isShowPaginate: {
            type: Boolean,
            default: false
        },
        isShowSearch: {
            type: Boolean,
            default: true
        },
        rawData: {
            type: Array,
            required: true
        },
        isShowCheckBox: {
            type: Boolean,
            default: false
        },
        isShowHeaderTable: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array
        },
        isServerPagination: {
            type: Boolean,
            default: false
        },
        defaultPaginationSize: {
            type: Number
        },
        paginationSizes: {
            type: Array,
            default: function () { return [20, 50, 100, 150]; }
        },
        serverTotalRows: {
            type: Number,
            default: 0
        },
        autoHeight: {
            type: Boolean,
            default: false
        },
        enableInfiniteScroll: {
            type: Boolean,
            default: false
        },
        isProject: {
            type: Boolean,
            default: false
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        isExport: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        sectionLastItem: function () {
            return this.totalRows < this.currentPage * this.paginationPageSize
                ? this.totalRows
                : this.currentPage * this.paginationPageSize;
        },
        totalRows: function () {
            if (this.isServerPagination) {
                return this.serverTotalRows;
            }
            return this.rawData.length;
        },
        paginationPageSize: function () {
            if (this.gridApi)
                return this.gridApi.paginationGetPageSize();
            else if (this.defaultPaginationSize)
                return this.defaultPaginationSize;
            else if (this.paginationSizes.length > 0)
                return this.paginationSizes[0];
            // set default pagination choice
            else
                return 50;
        },
        totalPages: function () {
            if (this.isServerPagination && this.serverTotalRows > 0) {
                return Math.ceil(this.serverTotalRows / this.paginationPageSize);
            }
            if (this.gridApi)
                return this.gridApi.paginationGetTotalPages();
            else
                return 1;
        },
        totalPageItems: function () {
            if (this.enableInfiniteScroll) {
                return this.rawData.length;
            }
            if (this.currentPage >= this.totalPages) {
                return this.rawData.length === this.paginationPageSize
                    ? this.rawData.length
                    : this.rawData.length % this.paginationPageSize;
            }
            return this.paginationPageSize;
        },
        currentPage: {
            get: function () {
                if (this.isServerPagination)
                    return this.serverCurrentPage + 1;
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                return 1;
            },
            set: function (val) {
                if (val === this.currentPage)
                    return;
                if (this.isServerPagination) {
                    this.serverCurrentPage = val - 1;
                    this.onServerPaginationChanged(val, this.paginationPageSize);
                }
                else {
                    this.gridApi.paginationGoToPage(val - 1);
                }
            }
        },
        userRole: function () {
            return this.$store.state.AppActiveUser.userRole.split(', ');
        },
        canImport: function () {
            return (this.userRole.includes('VIP') ||
                this.userRole.includes('Program') ||
                this.userRole.includes('Acquisition') ||
                this.userRole.includes('Feasibility'));
        }
    },
    methods: {
        onServerPaginationChanged: function (page, limit) {
            this.isLoadingData = true;
            var offset = (page - 1) * limit;
            this.$emit('pagination-changed', { limit: limit, offset: offset });
        },
        onPageSizeChange: function (size) {
            if (this.isServerPagination) {
                this.onServerPaginationChanged(this.currentPage, size);
            }
        },
        updateSearchQuery: function (val) {
            if (!this.isServerPagination) {
                this.gridApi.setQuickFilter(val);
                this.$emit('update-search', val);
            }
            else {
                this.debouncedFireUpdateSearch();
            }
        },
        onSelectionChanged: function () {
            var _this = this;
            this.isCheckboxSelection = true;
            var selectedRows = this.gridApi.getSelectedRows();
            this.$emit('input', selectedRows);
            this.$nextTick(function () {
                _this.isCheckboxSelection = false;
            });
        },
        onInnerWidthChanged: function () {
            this.gridApi.sizeColumnsToFit();
        },
        setSelectedEachNode: function () {
            var _this = this;
            this.gridApi.forEachNode(function (node) {
                node.setSelected(_this.value.findIndex(function (data) { return node.data.id === data.id; }) !== -1);
            });
        },
        handleScroll: function (event) {
            if (event.target.scrollingElement.scrollTop +
                event.target.scrollingElement.offsetHeight >
                this.$el.scrollHeight - this.gridOptions.rowHeight * 5 &&
                !this.scrollBottomFired) {
                this.$emit('scroll-to-bottom', { hasEnoughData: true });
                this.scrollBottomFired = true;
            }
        },
        getNoRow: function (index) {
            return (this.currentPage - 1) * this.paginationPageSize + 1 + index;
        },
        fetchEditPermission: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this;
                            return [4 /*yield*/, apiGateway.canEditProgram()];
                        case 1:
                            _a.canEdit = _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        editProject: function (index, projectId) {
            this.isPopupEdit = true;
            this.isIndexRow = index;
            this.isProjectId = projectId;
            this.isParam = {
                target_1_date: this.setDateParam(this.rawData[index].targetPresentSiteDate),
                target_1_icon_color: this.rawData[index].targetPresentSiteDate_Icon,
                target_1_font_color: this.rawData[index].targetPresentSiteDate_Font,
                target_2_date: this.setDateParam(this.rawData[index].targetTPMDate),
                target_2_icon_color: this.rawData[index].targetTPMDate_Icon,
                target_2_font_color: this.rawData[index].targetTPMDate_Font,
                target_3_date: this.setDateParam(this.rawData[index].targetHandOverDate),
                target_3_icon_color: this.rawData[index].targetHandOverDate_Icon,
                target_3_font_color: this.rawData[index].targetHandOverDate_Font,
                target_4_date: this.setDateParam(this.rawData[index].targetFirstCIADate),
                target_4_icon_color: this.rawData[index].targetFirstCIADate_Icon,
                target_4_font_color: this.rawData[index].targetFirstCIADate_Font,
                target_5_date: this.setDateParam(this.rawData[index].targetApproveDate),
                target_5_icon_color: this.rawData[index].targetApproveDate_Icon,
                target_5_font_color: this.rawData[index].targetApproveDate_Font,
                target_6_date: this.setDateParam(this.rawData[index].targetOpenDate),
                target_6_icon_color: this.rawData[index].targetOpenDate_Icon,
                target_6_font_color: this.rawData[index].targetOpenDate_Font,
                first_layout_date: this.setDateParam(this.rawData[index].firstLayoutDate),
                first_layout_date_icon_color: this.rawData[index].firstLayoutDate_Icon,
                first_layout_date_font_color: this.rawData[index].firstLayoutDate_Font,
                mall_leasing: this.rawData[index].mallLeasing,
                construction_progress: this.rawData[index].constructionProgress,
                mall_construction: this.rawData[index].mallConstruction,
                noted: this.rawData[index].noted
            };
        },
        closePopup: function (value) {
            this.isPopupEdit = value;
        },
        confirmEdit: function (value) {
            return __awaiter(this, void 0, void 0, function () {
                var index, projectId, target, payload, resp, rawData, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            index = value.index;
                            projectId = value.projectId;
                            target = value.target;
                            payload = {
                                targetPresentSiteDate: this.setDateUpdate(target.target_1_date),
                                targetPresentSiteDate_Font: target.target_1_font_color,
                                targetPresentSiteDate_Icon: target.target_1_icon_color,
                                targetTPMDate: this.setDateUpdate(target.target_2_date),
                                targetTPMDate_Font: target.target_2_font_color,
                                targetTPMDate_Icon: target.target_2_icon_color,
                                targetHandOverDate: this.setDateUpdate(target.target_3_date),
                                targetHandOverDate_Font: target.target_3_font_color,
                                targetHandOverDate_Icon: target.target_3_icon_color,
                                targetFirstCIADate: this.setDateUpdate(target.target_4_date),
                                targetFirstCIADate_Font: target.target_4_font_color,
                                targetFirstCIADate_Icon: target.target_4_icon_color,
                                targetApproveDate: this.setDateUpdate(target.target_5_date),
                                targetApproveDate_Font: target.target_5_font_color,
                                targetApproveDate_Icon: target.target_5_icon_color,
                                targetOpenDate: this.setDateUpdate(target.target_6_date),
                                targetOpenDate_Font: target.target_6_font_color,
                                targetOpenDate_Icon: target.target_6_icon_color,
                                firstLayoutDate: this.setDateUpdate(target.first_layout_date),
                                firstLayoutDate_Icon: target.first_layout_date_icon_color,
                                firstLayoutDate_Font: target.first_layout_date_font_color,
                                mallLeasing: target.mall_leasing,
                                constructionProgress: target.construction_progress,
                                mallConstruction: target.mall_construction,
                                noted: target.noted
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, apiGateway.updateTargetProject(projectId, payload)];
                        case 2:
                            resp = _a.sent();
                            if (resp.status === 200) {
                                rawData = Object.assign({}, this.rawData);
                                rawData[index]['targetPresentSiteDate'] = target.target_1_date;
                                rawData[index]['presentSiteDate'] = formatDate(target.target_1_date);
                                rawData[index]['targetPresentSiteDate_Font'] =
                                    target.target_1_font_color;
                                rawData[index]['targetPresentSiteDate_Icon'] =
                                    target.target_1_icon_color;
                                rawData[index]['targetTPMDate'] = target.target_2_date;
                                rawData[index]['tpmDate'] = formatDate(target.target_2_date);
                                rawData[index]['targetTPMDate_Font'] = target.target_2_font_color;
                                rawData[index]['targetTPMDate_Icon'] = target.target_2_icon_color;
                                rawData[index]['targetHandOverDate'] = target.target_3_date;
                                rawData[index]['handOverDate'] = formatDate(target.target_3_date);
                                rawData[index]['targetHandOverDate_Font'] = target.target_3_font_color;
                                rawData[index]['targetHandOverDate_Icon'] = target.target_3_icon_color;
                                rawData[index]['targetFirstCIADate'] = target.target_4_date;
                                rawData[index]['firstCIADate'] = formatDate(target.target_4_date);
                                rawData[index]['targetFirstCIADate_Font'] = target.target_4_font_color;
                                rawData[index]['targetFirstCIADate_Icon'] = target.target_4_icon_color;
                                rawData[index]['targetApproveDate'] = target.target_5_date;
                                rawData[index]['approveDate'] = formatDate(target.target_5_date);
                                rawData[index]['targetApproveDate_Font'] = target.target_5_font_color;
                                rawData[index]['targetApproveDate_Icon'] = target.target_5_icon_color;
                                rawData[index]['targetOpenDate'] = target.target_6_date;
                                rawData[index]['openDate'] = formatDate(target.target_6_date);
                                rawData[index]['targetOpenDate_Font'] = target.target_6_font_color;
                                rawData[index]['targetOpenDate_Icon'] = target.target_6_icon_color;
                                rawData[index]['firstLayoutDate'] = formatDate(target.first_layout_date);
                                rawData[index]['firstLayoutDate_Icon'] =
                                    target.first_layout_date_icon_color;
                                rawData[index]['firstLayoutDate_Font'] =
                                    target.first_layout_date_font_color;
                                rawData[index]['mallLeasing'] = target.mall_leasing;
                                rawData[index]['constructionProgress'] = target.construction_progress;
                                rawData[index]['mallConstruction'] = target.mall_construction;
                                rawData[index]['noted'] = target.noted;
                                this.isPopupEdit = false;
                                this.isIndexRow = null;
                                this.isProjectId = null;
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            this.isPopupEdit = false;
                            this.isIndexRow = null;
                            this.isProjectId = null;
                            this.isPopupError = true;
                            console.log(error_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        formatDate: function (date) {
            return formatDate(date);
        },
        setDateUpdate: function (date) {
            if (!date) {
                return null;
            }
            else {
                return new Date(date);
            }
        },
        setDateParam: function (date) {
            if (!date) {
                return null;
            }
            else {
                return moment(date).format('yyyy-MM-DD');
            }
        },
        exportProjects: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.$emit('export');
                    return [2 /*return*/];
                });
            });
        },
        importProjects: function (excelData) {
            return __awaiter(this, void 0, Promise, function () {
                var resp, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.log(excelData);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, apiGateway.importProjects(excelData.results.map(function (result) { return ({
                                    id: result.projectSystemId.value,
                                    targetApproveDate: result.targetApprovalDate.value,
                                    targetHandOverDate: result.targetSiteHandOver.value,
                                    targetOpenDate: result.targetGrandOpening.value,
                                    targetPresentSiteDate: result.targetPresentSite.value,
                                    targetFirstCIADate: result.target1stCia.value,
                                    targetTPMDate: result.targetTpmAmd.value,
                                    targetApproveDate_Icon: result.targetApprovalDateIconColor.value,
                                    targetApproveDate_Font: result.targetApprovalDateFontColor.value,
                                    targetHandOverDate_Icon: result.targetSiteHandOverIconColor.value,
                                    targetHandOverDate_Font: result.targetSiteHandOverFontColor.value,
                                    targetOpenDate_Icon: result.targetGrandOpeningIconColor.value,
                                    targetOpenDate_Font: result.targetGrandOpeningFontColor.value,
                                    targetPresentSiteDate_Icon: result.targetPresentSiteIconColor.value,
                                    targetPresentSiteDate_Font: result.targetPresentSiteFontColor.value,
                                    targetFirstCIADate_Icon: result.target1stCiaIconColor.value,
                                    targetFirstCIADate_Font: result.target1stCiaFontColor.value,
                                    targetTPMDate_Icon: result.targetTpmAmdIconColor.value,
                                    targetTPMDate_Font: result.targetTpmAmdFontColor.value,
                                    firstLayoutDate: result.firstLayoutDate.value,
                                    firstLayoutDate_Icon: result.firstLayoutDateIconColor.value,
                                    firstLayoutDate_Font: result.firstLayoutDateFontColor.value,
                                    mallLeasing: result.mallLeasing.value,
                                    constructionProgress: result.constructionProgress.value,
                                    mallConstruction: result.mallConstruction.value
                                }); }))];
                        case 2:
                            resp = _b.sent();
                            if (resp && resp.status === 200) {
                                this.$refs.importExcel.closePopup();
                                this.$vs.notify({
                                    color: 'success',
                                    title: 'Successful Import'
                                });
                                this.$emit('fetch');
                            }
                            else {
                                this.$refs.importExcel.closePopup();
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            _a = _b.sent();
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Import Failed'
                            });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        sortData: function (column_name, sort) {
            this.$emit('sort', {
                column: column_name,
                order_by: !sort ? 'desc' : 'asc'
            });
        }
    },
    watch: {
        value: function () {
            if (this.isShowCheckBox && !this.isCheckboxSelection) {
                this.setSelectedEachNode();
            }
        },
        rawData: {
            handler: function () {
                this.isLoadingData = false;
                this.scrollBottomFired = false;
                if (this.enableInfiniteScroll &&
                    this.rawData.length < this.minimumItemScrollable) {
                    this.$emit('scroll-to-bottom', { hasEnoughData: false });
                    this.scrollBottomFired = true;
                }
            },
            deep: true
        },
        projectStatus_select: {
            handler: function () {
                this.$emit('filter', this.projectStatus_select);
            },
            deep: true
        }
    },
    mounted: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchEditPermission()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    created: function () {
        var _this = this;
        if (this.isShowSearch) {
            this.debouncedFireUpdateSearch = debounce(function () {
                _this.isLoadingData = true;
                _this.$emit('update-search', _this.searchQuery);
            }, 500);
        }
        if (this.enableInfiniteScroll) {
            window.addEventListener('scroll', this.handleScroll);
        }
    },
    destroyed: function () {
        if (this.enableInfiniteScroll) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
};
